import { Styles } from 'shared/types';

export const DefaultTextField: Styles = {
  fontSize: 14,
  lineHeight: '143%',
  letterSpacing: 0.15,
  width: '100%',
};
